var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagesInStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9 8 13.726V30.14h24V13.726L20 9zm4.008 19.717H20.72V25.43h3.287v3.287zm-2.364-4.694h-3.288v-3.287h3.287v3.287zm-2.365 1.407v3.287h-3.287V25.43h3.287zm7.559 3.287h-1.424v-4.694H23.05V19.33h-6.1v4.693h-2.364v4.694h-1.424V17.842h13.676v10.875zm3.756.015h-2.35V16.436H11.756v12.296h-2.35V14.684L20 10.51l10.594 4.173v14.048z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesInStock);
export default __webpack_public_path__ + "static/media/packages-in-stock.5a30bb5f6227985ca4378beefc72aa42.svg";
export { ForwardRef as ReactComponent };